import React, { Fragment, useState, useEffect } from "react";
import FcardContact from "../../components/FcardContact/FcardContact";
import FcardGroup from "../../components/FcardGroup/FcardGroup";
import FcardPageTitle from "../../components/FcardPageTitle/FcardPageTitle";
import { useNavigate } from "react-router";
import FInfoCard from "../../components/FInfoCard/FInfoCard";
import { getcontactInfo, deleteContactInfoById } from "../../api/contactInfo";
import Floading from "../../components/Floading/Floading";
import Swal from "sweetalert2";
import PhoneInput from "react-phone-input-2";
import { useFormik } from "formik";
import FInputt from "../../components/FInputt/FInputt";
import { useContactInfo } from "../../hooks/useContactInfo";
import { usePhoneFormat } from "../../hooks/usePhoneFormat";
import jwt_decode from "jwt-decode";
import * as Yup from "yup";
import FContainer from "../../components/FContainer/FContainer";
import FInputText from "../../components/Finputs/FInputText/FInputText";
import Fbutton from "../../components/Finputs/FButton/Fbutton";

const CreatePhoneScreen = ({ param }) => {
  const route = useNavigate();
  const { sendOtpPhone } = useContactInfo();
  const {
    typingPhoneNumber,
    formatNumberToNationalWithoutSpaces,
    validateLocalPhone,
  } = usePhoneFormat();

  const [phoneNumber, setPhoneNumber] = useState("");
  const [countryCode, setCountryCode] = useState("+52");

  const tokennn = localStorage.getItem("token");
  const tokenDecode = jwt_decode(tokennn);


  const nextScreen = async (phone) => {
    if (tokenDecode.phoneNumber == phone) {
      Swal.fire({
        showCloseButton: true,
        title: 'Atención',
        text: "Este teléfono ya se encuentra registrado",
        icon: 'warning',
        showCancelButton: false,
        confirmButtonColor: '#fd6e0d',
        iconColor: "#fd6e0d",
        confirmButtonText: 'Entendido'
    })
    } else {
      route("/PhoneOTPScreen", {
        state: {
          typeOfContactId: "PHONE",
          contact: phone,
        },
      });
    }
  };

  const formik = useFormik({
    initialValues: {
      phoneNumber: "",
    },
    onSubmit: (values) => {
      const { phoneNumber } = values;
      //console.log({phoneNumber})
      nextScreen(phoneNumber);
    },
    validate: (values) => {
      const errors = {};

      if (!validateLocalPhone(values.phoneNumber)) {
        errors.phoneNumber = "Ingresa un número de teléfono válido.";
      }

      return errors;
    },
  });

  return (
    <>
      <div className="border-0 grid place-items-center">
        <div className="border-0 grid grid-cols-12 xss:w-[450px] place-items-center">
          <div className="border-0 col-span-5 p-5">
            <img
              src={require("../../components/assets/images/telephone.png")}
              className="w-full xxs:w-[120px] h-auto flex-1"
            />
          </div>
          <div className="border-0 col-span-7 grid grid-rows-2 text-center sm:py-7 ">
            <div className="border-0 row-span-1 font-bold text-Secondary text-[5vw] smm:text-[20px]">
              Asocia tu celular
            </div>
            <div className="border-0 row-span-1 font-regular text-[4vw] smm:text-[20px]">
              Crea tu número de celular
            </div>
          </div>
        </div>
      </div>

      <FContainer>
        <FInputText
          type="PhoneInput"
          title="Ingresa número celular"
          placeholder="Ingresa número celular"
          value={formik.values.phoneNumber}
          onChange={(value) => {
            formik.setFieldValue("phoneNumber", value);
          }}
          errorMessage={formik.errors.phoneNumber}
        />
        <Fbutton
          value="Continuar"
          disabled={!formik.isValid}
          onClick={formik.handleSubmit}
        />
      </FContainer>
    </>
  );
};

export default CreatePhoneScreen;
